import React from 'react'
import Portfolio from '../components/Portfolio/Portfolio'
import Nav from '../components/Nav/Nav'

const PortfolioPage = () => {
    return(
        <section>
            <Nav/>
            <div className="container-box">
            <Portfolio/>
            </div>
        </section>
    )
    
}

export default PortfolioPage